import colors from '@theme/colors';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  addPhoneText: {
    color: colors.neutral.cotton,
    // marginHorizontal: 8,
    // marginRight: 8,
    flex: 1,
    marginVertical: 2,
    textAlign: 'center',
  },
  addPhoneTextContainer: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  btnAddPhoneStyles: {
    backgroundColor: colors.neutral.cotton,
    borderColor: colors.disabled.smoke,
    borderRadius: 100,
    borderWidth: 1,
    flexDirection: 'row',
    marginHorizontal: 16,
    marginTop: 12,
  },
  btnAddPhoneTextContainer: {
    alignItems: 'center',
    alignSelf: 'center',
    flexDirection: 'row',
  },
  btnAddScreenStyles: {
    borderRadius: 100,
    flex: 1,
    marginLeft: 8,
    marginRight: 16,
    // maxHeight: 50, // Constrain button height
    // minHeight: 40,
  },
});
export default styles;
